import React from "react";
import { ProductsTableNameColumnProps } from "./products-table-name-column.props";
import { ProductNameCellStyled } from "./products-table-name-column.styles";

export const ProductsTableNameColumn = (props: ProductsTableNameColumnProps) => (
  <ProductNameCellStyled active={props.active} align="left">
    {props.name}
  </ProductNameCellStyled>
);
